// react imports
import React from "react";
import { useNavigate } from "react-router-dom";
import {BlurhashImage} from "../blurhash/BlurhashImage";

const GaleriaKategoriaCard = (props) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate('/galeriadetailpage/' + props.msg.id);
  };

  return (
    <div className="program-card-div" tabIndex="0" onClick={onClick} onKeyDown={(e) => { if (e.key === 'Enter') onClick(); }}>
        <div className="image-div">
            {
                props.msg.image ? (
                    <BlurhashImage alt={props.msg.title ?? ""} image={props.msg.image} blurhash={props.msg.imageBlurhash} />
                ) : null
            }
        </div>
        {/*
        <div className="datum-div">
            <span>{moment.unix(props.msg.datum).locale('hu').format('YYYY.MM.DD.')}</span>
                                                                                  </div>*/}
        <div className="text-div">
            <span>{props.msg.title}</span>
        </div>
    </div>
  );
};

export default GaleriaKategoriaCard;
